import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { products } from '../data/mock';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue } from
'../components/ui/select';

const Products = () => {
  const [colorFilter, setColorFilter] = useState('all');
  const [finishFilter, setFinishFilter] = useState('all');

  const filteredProducts = products.filter((product) => {
    if (colorFilter !== 'all' && product.colorCategory !== colorFilter) return false;
    if (finishFilter !== 'all' && !product.finishes.includes(finishFilter)) return false;
    return true;
  });

  const colorCategories = ['all', ...new Set(products.map((p) => p.colorCategory))];
  const allFinishes = ['all', ...new Set(products.flatMap((p) => p.finishes))];

  return (
    <div className="min-h-screen pt-20">
      {/* Header Section */}
      <section className="bg-[#FAFAF8] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold text-[#111111] mb-4">Our Products</h1>
          <p className="max-w-3xl !text-lg text-gray-600">Premium granite slabs
 from India's finest quarries. Export-quality materials with consistent grading and global shipping support.
          </p>
        </div>
      </section>

      {/* Filters */}
      <section className="bg-white border-b border-gray-200 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row gap-4 items-start md:items-center">
            <span className="text-sm font-semibold text-[#111111]">Filter by:</span>
            <div className="flex flex-wrap gap-4">
              <Select value={colorFilter} onValueChange={setColorFilter}>
                <SelectTrigger className="w-[180px]">
                  <SelectValue placeholder="Color" />
                </SelectTrigger>
                <SelectContent>
                  {colorCategories.map((color) =>
                  <SelectItem key={color} value={color}>
                      {color === 'all' ? 'All Colors' : color}
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>

              <Select value={finishFilter} onValueChange={setFinishFilter}>
                <SelectTrigger className="w-[180px]">
                  <SelectValue placeholder="Finish" />
                </SelectTrigger>
                <SelectContent>
                  {allFinishes.map((finish) =>
                  <SelectItem key={finish} value={finish}>
                      {finish === 'all' ? 'All Finishes' : finish}
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>

              {(colorFilter !== 'all' || finishFilter !== 'all') &&
              <Button
                variant="outline"
                size="sm"
                onClick={() => {
                  setColorFilter('all');
                  setFinishFilter('all');
                }}>

                  Clear Filters
                </Button>
              }
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredProducts.length === 0 ?
          <div className="text-center py-16">
              <p className="text-lg text-gray-600">No products found matching your filters.</p>
            </div> :

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredProducts.map((product) =>
            <Link key={product.id} to={`/products/${product.slug}`}>
                  <Card className="group overflow-hidden border-0 shadow-sm hover:shadow-xl transition-all duration-300 h-full">
                    <div className="aspect-square overflow-hidden">
                      <img
                    src={product.images[0]}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />

                    </div>
                    <CardContent className="p-6">
                      <h3 className="text-xl font-semibold mb-2 text-[#111111]">{product.name}</h3>
                      <p className="text-gray-600 text-sm mb-4 line-clamp-2">{product.description}</p>
                      <div className="space-y-2 text-sm text-gray-500">
                        <div className="flex justify-between">
                          <span>Origin:</span>
                          <span className="font-medium text-[#111111]">{product.origin}</span>
                        </div>
                        <div className="flex justify-between">
                          <span>Color:</span>
                          <span className="font-medium text-[#111111]">{product.colorCategory}</span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </Link>
            )}
            </div>
          }
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-[#FAFAF8] py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-[#111111] mb-4">
            Need Help Selecting the Right Granite?
          </h2>
          <p className="!text-lg mb-8 text-gray-600">Our expert team can help

          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-[#111111] text-white hover:bg-[#2a2a2a]">
              Contact Our Team
            </Button>
          </Link>
        </div>
      </section>
    </div>);

};

export default Products;